import NodeCache from 'node-cache';

export function createDotCache(stdTTL = 600, checkperiod = 120) {
    return new NodeCache({ stdTTL, checkperiod });
}

if (!global.nodeCache?.instance) {
    global.nodeCache = { instance: createDotCache() };
}

export const dotCache = global.nodeCache.instance;

export const getCacheKey = (key) => {
    var hash = 0;
    for (var i = 0; i < key.length; i++) {
        var code = key.charCodeAt(i);
        hash = (hash << 5) - hash + code;
        hash = hash & hash;
    }
    return hash;
};
